import { useState, useRef, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import styles from "./index.module.css";
import ClearIcon from "@mui/icons-material/Clear";
import axiosInstance from "../../../helpers/axios";

const OtpConsent = (props) => {
  const { openOtpConsent, submitApplicationToInReview,handleConsent, mobile } = props;
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const inputsRef = useRef([]);

  const sendOtp = async () => {
    const url = `/login/create-otp`;
    const payload = { mobile: mobile };
    try {
      await axiosInstance.post(url, payload);
    } catch (error) {
      alert("Error sending otp. ", error);
    }
  };

  useEffect(() => {
    let interval;
    if (openOtpConsent && isResendDisabled) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setIsResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [openOtpConsent, isResendDisabled]);

  useEffect(() => {
    if (openOtpConsent && timer === 30) {
      sendOtp();
    }
  }, [openOtpConsent]);

  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otpDigits];
    newOtp[index] = value;
    setOtpDigits(newOtp);
    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const verifyOtp = async () => {
    setLoading(true);
    const url = `/login/verify-otp`;
    const payload = { mobile: mobile, otp: otpDigits?.join("") };
    try {
      const response = await axiosInstance.post(url, payload);
      if (response?.data?.message === "Successful") {
        submitApplicationToInReview();
      }
    } catch (e) {
      setLoading(false);
      alert("Error verifing otp. Please enter valid otp", e?.message);
    }
  };

  const handleResend = () => {
    if (!isResendDisabled) {
      sendOtp();
      setOtpDigits(["", "", "", "", "", ""]);
      setTimer(30);
      setLoading(false);
      setIsResendDisabled(true);
    }
  };

  return (
    <Dialog open={openOtpConsent}>
      <DialogTitle className={styles.dialogTitle}>
        <Typography className={styles.title}>OTP Consent</Typography>
        {/* <ClearIcon onClick={handleConsent} sx={{ cursor: "pointer", "@media (max-width: 600px)":{fontSize: '18px'} }} /> */}
        <ClearIcon onClick={() => {
          handleConsent();         
          //window.location.reload(); 
        }}
        sx={{ cursor: "pointer", "@media (max-width: 600px)":{fontSize: '18px'} }} />

      </DialogTitle>
      <Typography
        variant="h6"
        textAlign="center"
        mt={2}
        className={styles.info}
      >
        {`Enter the OTP sent to mobile no ${mobile}`}
      </Typography>

      <DialogContent>
        <Box
          display="flex"
          justifyContent="center"
          gap={2}
          mb={2}
          sx={{
            width: 500,
            height: 50,
            "@media (max-width: 600px)": {
              flexWrap: "wrap",
              maxWidth: "100%",
            },
          }}
        >
          {otpDigits.map((digit, index) => (
            <TextField
              key={index}
              inputRef={(el) => (inputsRef.current[index] = el)}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: "center",
                  fontSize: "20px",
                  fontFamily: "Outfit",
                  fontWeight: "bold",
                },
              }}
              variant="outlined"
              sx={{
                width: 50,
                height: 40,
                "@media (max-width: 600px)": { width: 45 },
              }}
            />
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography className={styles.resendText}>
            {isResendDisabled
              ? `You can resend OTP in ${timer} seconds`
              : "Didn’t receive the OTP?"}
          </Typography>

          <Button
            onClick={handleResend}
            disabled={isResendDisabled}
            variant="text"
            className={styles.resendButton}
          >
            Resend OTP
          </Button>
        </Box>
      </DialogContent>
      {loading ? (
        <Button
          variant="contained"
          className={styles.loadingOtp}
          startIcon={<CircularProgress size={20} color="inherit" />}
        >
          Please wait...
        </Button>
      ) : (
        <Button
          onClick={verifyOtp}
          variant="contained"
          className={styles.submitOtp}
          disabled={otpDigits.some((digit) => digit === "")}
          loading={true}
        >
          Submit Consent
        </Button>
      )}
    </Dialog>
  );
};

export default OtpConsent;
